import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcWidthOfSearchbar',
})
export class CalcWidthOfSearchbarPipe implements PipeTransform {
  transform(items: any[], defaultSize: number, type: string): number {
    if (type === 's') {
      return defaultSize - items.filter((x) => x.activate).length / 0.33;
    } else {
      return defaultSize + items.filter((x) => x.activate).length;
    }
  }
}
